// App.jsx

import React, { useState, useEffect, useContext } from 'react';

import PersonForm from './components/PersonForm';
import PersonTable from './components/PersonTable';
import PaymentTable from './components/PaymentTable';
import FirmManager from './components/FirmManager'; // Importiramo FirmManager

import { AuthContext } from './config/AuthProvider';
import Login from './authPage/Login';

import { db, auth } from './config/firebase'; // Importamo db i auth
import { collection, getDocs, query, where, addDoc, deleteDoc, doc, setDoc, updateDoc } from 'firebase/firestore';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Modal from 'react-modal'; // Importiramo Modal iz react-modal

import './App.css'; // Importamo CSS

function App() {
  // Postojeća stanja
  const [people, setPeople] = useState([]);
  const [earningsData, setEarningsData] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const [selectedNationality, setSelectedNationality] = useState('Sve'); // Promijenjeno na 'Sve' kao default
  const [selectedPeriod, setSelectedPeriod] = useState(1); // Dodali smo selectedPeriod
  const [userPeriodData, setUserPeriodData] = useState({});
  const [uploadedWeeks, setUploadedWeeks] = useState([]); // Stanje za praćenje učitanih tjedana

  // Novo stanje za firme
  const [firms, setFirms] = useState([]);

  // Novo stanje za odabranu firmu
  const [selectedFirm, setSelectedFirm] = useState(''); // Početna vrijednost je '' što znači "Sve"

  const { currentUser } = useContext(AuthContext);

  const EARNINGS_COLUMN_NAME = 'total to be transfered to glover';

  // Stanje za upravljanje vidljivošću FirmManager modala
  const [isFirmManagerOpen, setIsFirmManagerOpen] = useState(false);

  const [isArchivedPersonsModalOpen, setIsArchivedPersonsModalOpen] = useState(false);
  const [isUploadedWeeksModalOpen, setIsUploadedWeeksModalOpen] = useState(false);
  const [isPersonFormOpen, setIsPersonFormOpen] = useState(false);

  useEffect(() => {
    if (selectedNationality !== 'Hrvat') {
      setSelectedPeriod(1);
    }
  }, [selectedNationality]);


  // Funkcija za dohvaćanje svih firmi
  const fetchFirms = async () => {
    try {
      const firmsCollection = collection(db, 'firms');
      const q = query(firmsCollection);
      const querySnapshot = await getDocs(q);
      const firmsData = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setFirms(firmsData);
    } catch (error) {
      console.error('Greška pri dohvaćanju firmi:', error);
    }
  };

  // Funkcija za provjeru i kreiranje Default firme ako ne postoji
  const ensureDefaultFirm = async () => {
    try {
      const defaultFirmRef = doc(db, 'firms', 'default');
      const defaultFirmSnap = await getDocs(query(collection(db, 'firms'), where('__name__', '==', 'default')));
      if (defaultFirmSnap.empty) {
        await setDoc(defaultFirmRef, {
          name: 'Default',
          createdAt: new Date()
        });
        console.log('Zadana firma kreirana.');
        setFirms(prevFirms => [...prevFirms, { id: 'default', name: 'Default', createdAt: new Date() }]);
      } else {
        const defaultFirm = defaultFirmSnap.docs[0].data();
        setFirms(prevFirms => [...prevFirms, { id: 'default', ...defaultFirm }]);
        console.log('Zadana firma već postoji.');
      }
    } catch (error) {
      console.error('Greška pri provjeri/zadavanju firme:', error);
    }
  };

  // Funkcija za dohvaćanje podataka po periodu za sve korisnike
  const fetchUserPeriodData = async () => {
    try {
      const qUserPeriod = query(
        collection(db, 'userPeriodData'),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth),
        where('period', '==', selectedPeriod)
      );
      const querySnapshot = await getDocs(qUserPeriod);
      const data = {};
      querySnapshot.forEach((doc) => {
        const docData = doc.data();
        data[docData.userId] = { id: doc.id, ...docData };
      });
      setUserPeriodData(data);
    } catch (e) {
      console.error('Greška pri dohvaćanju user period data:', e);
    }
  };

  // Funkcija za dohvaćanje učitanih tjedana iz "uploadedWeeks" kolekcije
  const fetchUploadedWeeks = async () => {
    try {
      let qUploadedWeeks = query(
        collection(db, 'uploadedWeeks'),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth)
      );

      // Ako je odabrana firma, dodajemo filter za firmId
      if (selectedFirm !== '') {
        qUploadedWeeks = query(qUploadedWeeks, where('firmId', '==', selectedFirm));
      }

      const querySnapshot = await getDocs(qUploadedWeeks);
      const weeks = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        week: doc.data().week,
        filename: doc.data().filename,
        year: doc.data().year,
        month: doc.data().month,
        firmId: doc.data().firmId // Dodajemo firmId
      }));
      setUploadedWeeks(weeks);
    } catch (e) {
      console.error('Greška pri dohvaćanju uploadedWeeks:', e);
    }
  };

  // Dohvaćanje podataka po periodu kad se promijene godina, mjesec, period ili firma
  useEffect(() => {
    fetchUserPeriodData();
    fetchUploadedWeeks();
  }, [selectedYear, selectedMonth, selectedPeriod, selectedFirm]);

  const fetchUsers = async () => {
    try {
      const qUsers = query(collection(db, 'users'));
      const querySnapshot = await getDocs(qUsers);
      const users = querySnapshot.docs.map((doc) => {
        const data = doc.data();
  
        return {
          id: doc.id,
          name: data.name || '',
          email: data.email || 'nema',
          city: data.city || '',
          comment: data.comment || '',
          nationality: data.nationality || 'Hrvat', // Default to 'Hrvat' if not specified
          tekuciRacun: data.tekuciRacun || '',
          zasticeniRacun: data.zasticeniRacun || '',
          riderID: data.riderID || '',
          firmId: data.firmId || 'default',
          appKnjig: data.appKnjig || 0,
          doprinosi: data.doprinosi || 0,
          fee: data.fee || 0,
          renta: data.renta || 0,
          rentSmjestaj: data.rentSmjestaj || 0,
          oprema: data.oprema || 0,
          akontacija: data.akontacija || 0,
          gorivo: data.gorivo || 0,
          ostalo: data.ostalo || 0,
          bonus: data.bonus || 0,
          // New fields for 'Stranac' (Foreigners)
          tarifa: data.tarifa || 0,
          depozit: data.depozit || 0,
          struja: data.struja || 0,
          glovoTax: data.glovoTax || 0,
          startMonth: data.startMonth || 9,
          startYear: data.startYear || 2024,
          archived: data.archived || false,
          archiveMonth: data.archiveMonth || null,
          archiveYear: data.archiveYear || null,
          imageUrl: data.imageUrl || null,
        };
      });
      setPeople(users);
      console.log('Dohvaćeni korisnici:', users);
    } catch (e) {
      console.error('Greška pri dohvaćanju korisnika:', e);
    }
  };
  

  // Funkcija za dohvaćanje zarada iz Firestorea
  const fetchEarnings = async () => {
    try {
      let qEarnings = query(
        collection(db, 'earnings'),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth)
      );

      // Ako je Hrvat, dodajemo filter za period
      if (selectedNationality === 'Hrvat') {
        qEarnings = query(qEarnings, where('period', '==', selectedPeriod));
      }

      const querySnapshot = await getDocs(qEarnings);
      const earnings = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setEarningsData(earnings);
      console.log('Dohvaćene zarade:', earnings);
    } catch (e) {
      console.error('Greška pri dohvaćanju zarada:', e);
    }
  };

  // Dohvaćanje firmi i osiguravanje da Default firma postoji kada je korisnik prijavljen
  useEffect(() => {
    if (currentUser) {
      ensureDefaultFirm();
      fetchFirms();
    }
  }, [currentUser]);

  // Dohvaćanje korisnika kada je korisnik prijavljen
  useEffect(() => {
    if (currentUser) {
      fetchUsers();
    }
  }, [currentUser]);

  // Dohvaćanje zarada kada je korisnik prijavljen ili se promijene filteri
  useEffect(() => {
    if (currentUser) {
      fetchEarnings();
      fetchUploadedWeeks(); // Osiguravamo da su učitani tjedni ažurirani
    }
  }, [currentUser, selectedYear, selectedMonth, selectedPeriod, selectedNationality, selectedFirm]);

  // Funkcija za dodavanje nove osobe
  const addPerson = async (person) => {
    // Provjera jedinstvenosti Rider ID-a
    const riderIDQuery = query(
      collection(db, 'users'),
      where('riderID', '==', person.riderID)
    );
    const riderIDSnapshot = await getDocs(riderIDQuery);
    if (!riderIDSnapshot.empty) {
      alert('Rider ID već postoji. Molimo unesite jedinstveni Rider ID.');
      return;
    }

    // Provjera da li je odabrana firma validna
    const selectedFirmObj = firms.find(firm => firm.id === person.firmId);
    if (!selectedFirmObj) {
      alert('Odabrana firma ne postoji.');
      return;
    }

    // Spremanje u Firestore
    try {
      const docRef = await addDoc(collection(db, 'users'), person);
      console.log('Korisnik dodan s ID-om:', docRef.id);
      // Ažuriranje lokalnog stanja
      setPeople([...people, { id: docRef.id, ...person }]);
      alert('Korisnik uspješno dodan!');
    } catch (e) {
      console.error('Greška pri dodavanju korisnika:', e);
      alert('Došlo je do greške prilikom dodavanja korisnika. Pokušajte ponovno.');
    }
  };

  // Funkcija za ažuriranje zarada
  const updateEarnings = async (week, data, filename) => {
    console.log('Excel Podaci:', data);
    console.log('Trenutno stanje korisnika:', people);
    console.log('Tjedan:', week);
  
    const year = selectedYear;
    const month = selectedMonth;
    const firmId = selectedFirm; // Koristimo odabranu firmu
    const uniqueWeekId = `${year}-${month}-${week}-${firmId}`; // Uključujemo firmId u ID
  
    // Validacija: Provjera je li firma odabrana
    if (firmId === '') {
      alert('Molimo odaberite firmu prije upload-a.');
      return;
    }
  
    // Provjera da li je tjedan već uvezen za tu firmu
    const existingWeek = uploadedWeeks.find(
      (w) => w.week === week && w.year === year && w.month === month && w.firmId === firmId
    );
  
    if (existingWeek) {
      alert(`Tjedan ${week} za ${month}/${year} i firmu ${getFirmName(firmId)} je već uvezen.`);
      return; // Prekidamo proces ako je tjedan već uvezen za tu firmu
    }
  
    // Skup korisnika kojima su ažurirane zarade
    const updatedUserIds = new Set();
  
    for (const item of data) {
      // Provjera i normalizacija Rider ID-a
      const riderIDRaw = item.riderid;
      console.log('Originalni Rider ID iz Excela:', riderIDRaw);
  
      let riderID = null;
      if (typeof riderIDRaw === 'string') {
        riderID = riderIDRaw.trim().toLowerCase();
      } else if (riderIDRaw != null) {
        // Ako nije string, pokušaj ga pretvoriti u string
        riderID = String(riderIDRaw).trim().toLowerCase();
      }
  
      if (!riderID) {
        console.log('Rider ID nije prisutan ili je neispravan u Excel podacima za unos.');
        continue;
      }
  
      // Pronalazak osobe s odgovarajućim Rider ID-om
      const person = people.find(
        (p) => p.riderID && p.riderID.trim().toLowerCase() === riderID
      );
  
      if (person) {
        const earningsKey = EARNINGS_COLUMN_NAME.toLowerCase().replace(/\s+/g, '');
        const earningsValue = item[earningsKey]; // 'totaltobettransferedtoglover'
        console.log(`Zarada za ${person.name}:`, earningsValue);
  
        if (earningsValue !== undefined) {
          let period;
  
          if (person.nationality === 'Hrvat') {
            if (week >= 1 && week <= 2) {
              period = 1;
            } else if (week >= 3 && week <= 5) {
              period = 2;
            } else {
              console.error(`Nevažeći tjedan ${week} za Hrvata`);
              continue; // Preskačemo ako je tjedan izvan očekivanog raspona
            }
          } else {
            // Za strance period je uvijek 1
            period = 1;
          }
  
          // Spremanje zarade u Firestore
          try {
            await addDoc(collection(db, 'earnings'), {
              userId: person.id,
              year,
              month,
              period,
              week,
              amount: earningsValue,
              firmId, // Dodajemo firmId u zaradu
            });
            console.log(`Zarada spremljena za ${person.name} za tjedan ${week}`);
          } catch (e) {
            console.error('Greška pri spremanju zarade:', e);
          }
  
          // Dodavanje korisnika u skup ažuriranih korisnika
          updatedUserIds.add(person.id);
  
        } else {
          console.log(
            `Zarada kolone "${EARNINGS_COLUMN_NAME}" nije pronađena u earningData`
          );
        }
      } else {
        console.log(`Nije pronađen korisnik za Rider ID: ${riderID}`);
      }
    }
  
    // Nakon što su svi podaci procesirani, dodajemo tjedan u 'uploadedWeeks'
    try {
      await setDoc(doc(db, 'uploadedWeeks', uniqueWeekId), {
        week,
        year,
        month,
        filename,
        firmId, // Dodajemo firmId
      });
      setUploadedWeeks([...uploadedWeeks, { id: uniqueWeekId, week, filename, year, month, firmId }]);
      alert(`Tjedan ${week} za ${month}/${year} i firmu ${getFirmName(firmId)} je uspješno uvezen.`);
    } catch (e) {
      console.error('Greška pri dodavanju u uploadedWeeks:', e);
      alert('Došlo je do greške prilikom označavanja tjedna kao učitanog.');
    }
  
    // **Nova logika za kreiranje userPeriodData s defaultnim vrijednostima**
    try {
      for (const userId of updatedUserIds) {
        const person = people.find((p) => p.id === userId);
        if (!person) continue;
  
        let period;
  
        if (person.nationality === 'Hrvat') {
          if (week >= 1 && week <= 2) {
            period = 1;
          } else if (week >= 3 && week <= 5) {
            period = 2;
          } else {
            console.error(`Nevažeći tjedan ${week} za Hrvata`);
            continue; // Preskačemo ako je tjedan izvan očekivanog raspona
          }
        } else {
          // Za strance period je uvijek 1
          period = 1;
        }
  
        // Provjera postoji li već userPeriodData za ovog korisnika u ovom periodu
        const userPeriodQuery = query(
          collection(db, 'userPeriodData'),
          where('userId', '==', person.id),
          where('year', '==', year),
          where('month', '==', month),
          where('period', '==', period)
        );
        const userPeriodSnapshot = await getDocs(userPeriodQuery);
  
        if (userPeriodSnapshot.empty) {
          // Kreiramo userPeriodData s defaultnim vrijednostima iz person
          const newUserPeriodData = {
            userId: person.id,
            year,
            month,
            period,
            fee: person.fee || 0,
            appKnjig: person.appKnjig || 0,
            doprinosi: person.doprinosi || 0,
            renta: person.renta || 0,
            rentSmjestaj: person.rentSmjestaj || 0,
            oprema: person.oprema || 0,
            akontacija: person.akontacija || 0,
            gorivo: person.gorivo || 0,
            ostalo: person.ostalo || 0,
            bonus: person.bonus || 0,
            napomena: '',
            zaradaTotal: 0,
            feeAmount: 0,
            total1: 0,
            total2: 0,
          };
        
          if (person.nationality === 'Stranac') {
            newUserPeriodData.tarifa = person.tarifa || 0;
            newUserPeriodData.depozit = person.depozit || 0;
            newUserPeriodData.struja = person.struja || 0;
            newUserPeriodData.glovoTax = person.glovoTax || 0;
          }
        
          await addDoc(collection(db, 'userPeriodData'), newUserPeriodData);
          console.log(`Kreiran userPeriodData za korisnika ${person.name} za period ${period}/${month}/${year}`);
        }
      }
    } catch (e) {
      console.error('Greška pri kreiranju userPeriodData:', e);
    }
  
    // Nakon spremanja, osvježavamo podatke
    refreshData();
  };

  // Funkcija za dohvaćanje imena firme na temelju firmId
  const getFirmName = (firmId) => {
    const firm = firms.find(firm => firm.id === firmId);
    return firm ? firm.name : 'Default';
  };

  // Funkcija za brisanje zarada za određeni tjedan i firmu
  const deleteEarningsForWeek = async (week, firmId) => { // Izmijenjeno da prima firmId
    if (!window.confirm(`Jeste li sigurni da želite obrisati sve zarade za tjedan ${week} i firmu ${getFirmName(firmId)}?`)) {
      return;
    }

    try {
      // Dohvaćanje učitanih tjedana koji odgovaraju odabranom tjednu, godini, mjesecu i firmi
      const qWeeks = query(
        collection(db, 'uploadedWeeks'),
        where('week', '==', week),
        where('year', '==', selectedYear),
        where('month', '==', selectedMonth),
        where('firmId', '==', firmId) // Dodajemo filter za firmId
      );

      const weeksSnapshot = await getDocs(qWeeks);

      if (weeksSnapshot.empty) {
        alert('Nema učitanih tjedana za ovaj kriterij.');
        return;
      }

      // Brisanje zarada i uploadedWeeks za svaki pronađeni tjedan
      for (const weekDoc of weeksSnapshot.docs) {
        const weekData = weekDoc.data();
        const firmId = weekData.firmId;

        // Brisanje zarada iz "earnings" kolekcije za taj tjedan i firmu
        const qEarnings = query(
          collection(db, 'earnings'),
          where('year', '==', selectedYear),
          where('month', '==', selectedMonth),
          where('week', '==', week),
          where('firmId', '==', firmId)
        );
        const earningsSnapshot = await getDocs(qEarnings);

        const deletePromises = earningsSnapshot.docs.map((docSnap) =>
          deleteDoc(doc(db, 'earnings', docSnap.id))
        );

        await Promise.all(deletePromises);
        console.log(`Sve zarade za tjedan ${week} i firmu ${getFirmName(firmId)} su izbrisane.`);

        // Brisanje iz "uploadedWeeks" kolekcije
        await deleteDoc(doc(db, 'uploadedWeeks', weekDoc.id));
        console.log(`Tjedan ${week} za firmu ${getFirmName(firmId)} je izbrisan iz uploadedWeeks.`);

        // Ažuriranje stanja uploadedWeeks
        setUploadedWeeks(uploadedWeeks.filter((w) => w.id !== weekDoc.id));
      }

      // Ažuriramo zarade nakon brisanja
      refreshData();
    } catch (e) {
      console.error(`Greška pri brisanju zarada za tjedan ${week} i firmu ${firmId}:`, e);
    }
  };

  // Funkcija za brisanje osobe
  const handleDeletePerson = (personId) => {
    // Uklanjanje osobe iz lokalnog stanja
    setPeople(people.filter((person) => person.id !== personId));
    // Ažuriranje zarada i učitanih tjedana
    refreshData();
  };

  // Funkcija za ažuriranje osobe u lokalnom stanju
  const handleUpdatePerson = (updatedPerson) => {
    setPeople((prevPeople) =>
      prevPeople.map((person) =>
        person.id === updatedPerson.id ? updatedPerson : person
      )
    );
  };

  // Funkcija za osvježavanje podataka
  const refreshData = () => {
    fetchEarnings();
    fetchUserPeriodData();
    fetchUploadedWeeks();
    fetchFirms(); // Osvježava i firme, u slučaju promjena
    fetchUsers(); // Osvježava i korisnike
  };

  // Funkcija za ažuriranje napomene
  const updateNapomena = async (userId, year, month, period, newNapomena) => {
    try {
      const napomenaQuery = query(
        collection(db, 'userPeriodData'),
        where('userId', '==', userId),
        where('year', '==', year),
        where('month', '==', month),
        where('period', '==', period)
      );
      const napomenaSnapshot = await getDocs(napomenaQuery);

      if (!napomenaSnapshot.empty) {
        const docRef = napomenaSnapshot.docs[0].ref;
        await updateDoc(docRef, {
          napomena: newNapomena,
        });
      } else {
        // Ako dokument ne postoji, kreiraj novi
        await addDoc(collection(db, 'userPeriodData'), {
          userId,
          year,
          month,
          period,
          napomena: newNapomena,
          // Ostali potrebni podaci mogu biti dodani ovdje ako je potrebno
        });
      }

      // Osvježavanje podataka nakon ažuriranja
      refreshData();
    } catch (e) {
      console.error('Greška pri ažuriranju napomene:', e);
      alert('Došlo je do greške prilikom ažuriranja napomene. Pokušajte ponovno.');
    }
  };

  // Funkcija za prebacivanje korisnika u Default firmu prilikom brisanja firme
  const moveUsersToDefaultFirm = async (firmIdToDelete) => {
    try {
      // Dohvaćanje svih korisnika koji pripadaju obrisanoj firmi
      const qUsers = query(
        collection(db, 'users'),
        where('firmId', '==', firmIdToDelete)
      );
      const usersSnapshot = await getDocs(qUsers);

      const updatePromises = usersSnapshot.docs.map((docSnap) =>
        updateDoc(doc(db, 'users', docSnap.id), { firmId: 'default' })
      );

      await Promise.all(updatePromises);
      console.log(`Sve osobe iz firme ${firmIdToDelete} prebačene u Default firmu.`);
      // Osvježavanje podataka nakon prebacivanja
      refreshData();
    } catch (error) {
      console.error('Greška pri prebacivanju korisnika u Default firmu:', error);
      alert('Došlo je do greške prilikom prebacivanja korisnika u Default firmu.');
    }
  };

  const unarchivePerson = async (personId) => {
    try {
      await updateDoc(doc(db, 'users', personId), {
        archived: false,
        archiveMonth: null,
        archiveYear: null,
      });
      setPeople((prevPeople) =>
        prevPeople.map((person) =>
          person.id === personId ? { ...person, archived: false, archiveMonth: null, archiveYear: null } : person
        )
      );
      alert('Osoba uspješno odarhivirana!');
    } catch (e) {
      console.error('Greška pri odarhiviranju korisnika:', e);
      alert('Došlo je do greške prilikom odarhiviranja korisnika. Pokušajte ponovno.');
    }
  };

  const handleExportPersonTable = async () => {
    // Određivanje broja tjedana i početnog tjedna
    let numOfWeeks;
    let startWeek;
  
    if (selectedNationality === 'Hrvat') {
      if (selectedPeriod === 1) {
        numOfWeeks = 2; // Weeks 1 and 2
        startWeek = 1;
      } else if (selectedPeriod === 2) {
        numOfWeeks = 3; // Weeks 3, 4, and 5
        startWeek = 3;
      }
    } else {
      numOfWeeks = 5; // For "Stranac" or "Sve"
      startWeek = 1;
    }

    // Filtriranje osoba kao u PersonTable
    const filteredPeople = people
      .filter((person) => {
        const nationalityMatch =
          selectedNationality === 'Sve' || person.nationality === selectedNationality;
        const firmMatch = selectedFirm === '' || person.firmId === selectedFirm;
        const dateMatch =
          (person.startYear < selectedYear ||
            (person.startYear === selectedYear && person.startMonth <= selectedMonth)) &&
          (!person.archived ||
            person.archiveYear > selectedYear ||
            (person.archiveYear === selectedYear && person.archiveMonth > selectedMonth));
        return nationalityMatch && firmMatch && dateMatch;
      })
      .sort((a, b) => {
        if (selectedFirm === '') {
          // Sortiranje po imenu firme ako firma nije odabrana
          const firmA = firms.find((firm) => firm.id === a.firmId)?.name || '';
          const firmB = firms.find((firm) => firm.id === b.firmId)?.name || '';
          if (firmA === firmB) {
            return a.id.localeCompare(b.id);
          }
          return firmA.localeCompare(firmB);
        } else {
          // Ako je firma odabrana, sortiranje po ID-u osobe
          return a.id.localeCompare(b.id);
        }
      });
  
    // Priprema podataka za izvoz
    const exportData = [];
  
    // Inicijalizacija suma
    const sums = {
      // Sume po tjednima
      ...Array.from({ length: numOfWeeks }, (_, i) => [`tjedan${startWeek + i}`, 0]).reduce(
        (acc, [key, value]) => {
          acc[key] = value;
          return acc;
        },
        {}
      ),
      // Wolt zarade
      w1: 0,
      w2: 0,
      // Ostale sume
      zaradaTotal: 0,
      feeIznos: 0,
      total1: 0,
      appKnjig: 0,
      doprinosi: 0,
      renta: 0,
      rentSmjestaj: 0,
      oprema: 0,
      akontacija: 0,
      gorivo: 0,
      ostalo: 0,
      bonus: 0,
      total2: 0,
      tarifa: 0,
      depozit: 0,
      struja: 0,
      glovoTax: 0,
    };
  
    // Iterating through filtered people
    for (const person of filteredPeople) {
      // Filtering earnings for this person
      let personEarnings = earningsData.filter(
        (earning) =>
          earning.userId === person.id &&
          earning.year === selectedYear &&
          earning.month === selectedMonth
      );

      // Apply period filters based on nationality
      if (person.nationality === 'Hrvat') {
        if (selectedNationality === 'Hrvat') {
          personEarnings = personEarnings.filter(
            (earning) => earning.period === selectedPeriod
          );
        } else if (selectedNationality === 'Sve') {
          personEarnings = personEarnings.filter(
            (earning) => earning.period === 1 || earning.period === 2
          );
        }
      } else if (person.nationality === 'Stranac') {
        personEarnings = personEarnings.filter((earning) => earning.period === 1);
      }

      // Initialization of weekly earnings
      const earnings = new Array(numOfWeeks).fill(0);
      const woltEarnings = [0, 0]; // W1 i W2

      // Collecting earnings per week (Glovo) i Wolt zarade
      personEarnings.forEach((earning) => {
        // Provjera je li to Wolt zarada
        const isWolt = earning.platform === 'wolt' || earning.week === 'w1' || earning.week === 'w2';
        
        if (isWolt) {
          // Wolt zarade - W1 ili W2
          if (earning.week === 'w1') {
            woltEarnings[0] += parseFloat(earning.amount) || 0;
          } else if (earning.week === 'w2') {
            woltEarnings[1] += parseFloat(earning.amount) || 0;
          }
        } else {
          // Glovo zarade - normalni tjedni
          for (let i = 0; i < numOfWeeks; i++) {
            const weekNumber = startWeek + i;
            if (earning.week === weekNumber) {
              earnings[i] += parseFloat(earning.amount) || 0;
            }
          }
        }
      });

      // Fetching financial data
      const personData = userPeriodData[person.id] || {
        fee: person.fee || 0,
        appKnjig: person.appKnjig || 0,
        doprinosi: person.doprinosi || 0,
        renta: person.renta || 0,
        rentSmjestaj: person.rentSmjestaj || 0,
        oprema: person.oprema || 0,
        akontacija: person.akontacija || 0,
        gorivo: person.gorivo || 0,
        ostalo: person.ostalo || 0,
        bonus: person.bonus || 0,
        tarifa: person.tarifa || 0,
        depozit: person.depozit || 0,
        struja: person.struja || 0,
        glovoTax: person.glovoTax || 0,
      };

      // Calculating earnings (uključuje i Glovo i Wolt)
      const glovoTotal = earnings.reduce((sum, earning) => sum + earning, 0);
      const woltTotal = woltEarnings.reduce((sum, earning) => sum + earning, 0);
      const zaradaTotal = glovoTotal + woltTotal;
      const feeIznos = (zaradaTotal * (personData.fee || 0)) / 100;
      const total1 = zaradaTotal - feeIznos;
      const total2 =
        total1 -
        (parseFloat(personData.appKnjig) || 0) -
        (parseFloat(personData.doprinosi) || 0) -
        (parseFloat(personData.renta) || 0) -
        (parseFloat(personData.rentSmjestaj) || 0) -
        (parseFloat(personData.oprema) || 0) -
        (parseFloat(personData.akontacija) || 0) -
        (parseFloat(personData.gorivo) || 0) -
        (parseFloat(personData.ostalo) || 0) +
        (parseFloat(personData.bonus) || 0) -
        (person.nationality === 'Stranac'
          ? (parseFloat(personData.tarifa) || 0) +
            (parseFloat(personData.depozit) || 0) +
            (parseFloat(personData.struja) || 0) +
            (parseFloat(personData.glovoTax) || 0)
          : 0);

      // Preparing row for Excel
      const rowData = {
        name: person.name,
        riderID: person.riderID,
        firm: getFirmName(person.firmId),
        nationality: person.nationality === 'Hrvat' ? 'H' : 'S',
        ...earnings.reduce((acc, earning, index) => {
          acc[`tjedan${startWeek + index}`] = earning.toFixed(2);
          return acc;
        }, {}),
        w1: woltEarnings[0].toFixed(2),
        w2: woltEarnings[1].toFixed(2),
        zaradaTotal: zaradaTotal.toFixed(2),
        fee: personData.fee || 0,
        feeIznos: feeIznos.toFixed(2),
        total1: total1.toFixed(2),
        appKnjig: (parseFloat(personData.appKnjig) || 0).toFixed(2),
        doprinosi: (parseFloat(personData.doprinosi) || 0).toFixed(2),
        renta: (parseFloat(personData.renta) || 0).toFixed(2),
        rentSmjestaj: (parseFloat(personData.rentSmjestaj) || 0).toFixed(2),
        tarifa: (parseFloat(personData.tarifa) || 0).toFixed(2),
        depozit: (parseFloat(personData.depozit) || 0).toFixed(2),
        struja: (parseFloat(personData.struja) || 0).toFixed(2),
        glovoTax: (parseFloat(personData.glovoTax) || 0).toFixed(2),
        oprema: (parseFloat(personData.oprema) || 0).toFixed(2),
        akontacija: (parseFloat(personData.akontacija) || 0).toFixed(2),
        gorivo: (parseFloat(personData.gorivo) || 0).toFixed(2),
        ostalo: (parseFloat(personData.ostalo) || 0).toFixed(2),
        bonus: (parseFloat(personData.bonus) || 0).toFixed(2),
        total2: total2.toFixed(2),
      };

      // Adding row to exportData
      exportData.push(rowData);

      // Updating sums
      for (let i = 0; i < numOfWeeks; i++) {
        const weekKey = `tjedan${startWeek + i}`;
        sums[weekKey] += parseFloat(rowData[weekKey]);
      }
      sums.w1 += woltEarnings[0];
      sums.w2 += woltEarnings[1];
      sums.zaradaTotal += zaradaTotal;
      sums.feeIznos += feeIznos;
      sums.total1 += total1;
      sums.appKnjig += parseFloat(personData.appKnjig) || 0;
      sums.doprinosi += parseFloat(personData.doprinosi) || 0;
      sums.renta += parseFloat(personData.renta) || 0;
      sums.rentSmjestaj += parseFloat(personData.rentSmjestaj) || 0;
      sums.oprema += parseFloat(personData.oprema) || 0;
      sums.akontacija += parseFloat(personData.akontacija) || 0;
      sums.gorivo += parseFloat(personData.gorivo) || 0;
      sums.ostalo += parseFloat(personData.ostalo) || 0;
      sums.bonus += parseFloat(personData.bonus) || 0;
      sums.total2 += total2;
      sums.tarifa += parseFloat(personData.tarifa) || 0;
      sums.depozit += parseFloat(personData.depozit) || 0;
      sums.struja += parseFloat(personData.struja) || 0;
      sums.glovoTax += parseFloat(personData.glovoTax) || 0;
    }
  
    // Generiranje Excel datoteke
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Obračun');
  
    // Definicija stupaca
    const columns = [
      { header: 'Ime', key: 'name', width: 20 },
      { header: 'Rider ID', key: 'riderID', width: 15 },
      { header: 'Firma', key: 'firm', width: 20 },
      { header: 'N', key: 'nationality', width: 5 },
      // Tjedni
      ...Array.from({ length: numOfWeeks }, (_, i) => ({
        header: `Tjedan ${startWeek + i}`,
        key: `tjedan${startWeek + i}`,
        width: 10,
      })),
      { header: 'W1', key: 'w1', width: 10 },
      { header: 'W2', key: 'w2', width: 10 },
      { header: 'Zarada Total', key: 'zaradaTotal', width: 15 },
      { header: 'Fee %', key: 'fee', width: 10 },
      { header: 'FEE Iznos', key: 'feeIznos', width: 15 },
      { header: 'Total 1', key: 'total1', width: 15 },
      { header: 'App Knjig.', key: 'appKnjig', width: 15 },
      { header: 'Doprinosi', key: 'doprinosi', width: 15 },
      { header: 'Renta', key: 'renta', width: 15 },
      { header: 'Rent smještaj', key: 'rentSmjestaj', width: 15 },
      { header: 'Tarifa', key: 'tarifa', width: 15 },
      { header: 'Depozit', key: 'depozit', width: 15 },
      { header: 'Struja', key: 'struja', width: 15 },
      { header: 'O.T.', key: 'glovoTax', width: 15 },
      { header: 'Oprema', key: 'oprema', width: 15 },
      { header: 'Akontacija', key: 'akontacija', width: 15 },
      { header: 'Gorivo', key: 'gorivo', width: 15 },
      { header: 'Ostalo', key: 'ostalo', width: 15 },
      { header: 'Bonus', key: 'bonus', width: 15 },
      { header: 'Total 2', key: 'total2', width: 15 },
    ];
  
    worksheet.columns = columns;
  
    // Dodavanje podataka
    exportData.forEach((row) => {
      worksheet.addRow(row);
    });
  
    // Dodavanje suma
    const sumsRowData = {
      name: 'Suma',
      ...Array.from({ length: numOfWeeks }, (_, i) => {
        const weekKey = `tjedan${startWeek + i}`;
        return { [weekKey]: sums[weekKey].toFixed(2) };
      }).reduce((acc, curr) => ({ ...acc, ...curr }), {}),
      w1: sums.w1.toFixed(2),
      w2: sums.w2.toFixed(2),
      zaradaTotal: sums.zaradaTotal.toFixed(2),
      feeIznos: sums.feeIznos.toFixed(2),
      total1: sums.total1.toFixed(2),
      appKnjig: sums.appKnjig.toFixed(2),
      doprinosi: sums.doprinosi.toFixed(2),
      renta: sums.renta.toFixed(2),
      rentSmjestaj: sums.rentSmjestaj.toFixed(2),
      tarifa: sums.tarifa.toFixed(2),
      depozit: sums.depozit.toFixed(2),
      struja: sums.struja.toFixed(2),
      glovoTax: sums.glovoTax.toFixed(2),
      oprema: sums.oprema.toFixed(2),
      akontacija: sums.akontacija.toFixed(2),
      gorivo: sums.gorivo.toFixed(2),
      ostalo: sums.ostalo.toFixed(2),
      bonus: sums.bonus.toFixed(2),
      total2: sums.total2.toFixed(2),
    };
  
    // Dodavanje reda sa sumama
    worksheet.addRow(sumsRowData);
  
    // Stiliziranje zaglavlja i suma
    worksheet.getRow(1).font = { bold: true };
    worksheet.getRow(worksheet.lastRow.number).font = { bold: true };
  
    // Određivanje imena firme za naziv datoteke
    const firmNameForFile = selectedFirm
      ? getFirmName(selectedFirm).replace(/[^a-z0-9]/gi, '_')
      : 'sve';
  
    // Preuzimanje datoteke s imenom koje uključuje ime firme
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `Obračun_${firmNameForFile}_${selectedMonth}_${selectedYear}_P${selectedPeriod}.xlsx`
    );
  };
  
  return (
    <div>
      {currentUser ? (
        <div>
          {/* Filtri za nacionalnost, godinu, mjesec i firmu */}
          <div className="filter-form">
            <div className="filter-controls">
              <label>Nacionalnost:</label>
              <select
                value={selectedNationality}
                onChange={(e) => setSelectedNationality(e.target.value)}
              >
                <option value="Sve">Sve</option>
                <option value="Hrvat">Hrvat</option>
                <option value="Stranac">Stranac</option>
              </select>

              <label>Firma:</label>
              <select
                value={selectedFirm}
                onChange={(e) => setSelectedFirm(e.target.value)}
              >
                <option value="">Sve</option>
                {firms.filter(firm => firm.id !== 'default').map((firm) => (
                  <option key={firm.id} value={firm.id}>
                    {firm.name}
                  </option>
                ))}
              </select>

              <label>Godina:</label>
              <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              >
                {Array.from({ length: new Date().getFullYear() + 1 - 2022 + 1 }, (_, i) => 2022 + i).map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>

              <label>Mjesec:</label>
              <select
                value={selectedMonth}
                onChange={(e) => setSelectedMonth(parseInt(e.target.value))}
              >
                {[...Array(12)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                ))}
              </select>

              {/* Ako je nacionalnost Hrvat, prikazujemo filter za period */}
              {selectedNationality === 'Hrvat' && (
                <>
                  <label>Period:</label>
                  <select
                    value={selectedPeriod}
                    onChange={(e) => setSelectedPeriod(parseInt(e.target.value))}
                  >
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                  </select>
                </>
              )}
            </div>

            <div className="toolbar-buttons">
              <button onClick={handleExportPersonTable} className="export-button">
                Izvezi obračun tablicu
              </button>

              <button onClick={() => setIsFirmManagerOpen(true)} className="manage-firms-button">
                Upravljaj firmama
              </button>

              <button onClick={() => setIsArchivedPersonsModalOpen(true)} className="manage-firms-button">
                Arhivirane osobe
              </button>

              <button onClick={() => setIsUploadedWeeksModalOpen(true)} className="manage-firms-button">
                Učitani tjedni
              </button>

              <button onClick={() => setIsPersonFormOpen(true)} className="add-person-button">
                Dodaj osobu
              </button>
            </div>
          </div>

          {/* Prosljeđujemo listu firmi PersonForm */}
          <Modal
            isOpen={isPersonFormOpen}
            onRequestClose={() => setIsPersonFormOpen(false)}
            contentLabel="Dodaj osobu"
            className="modal"
            overlayClassName="overlay"
          >
            <PersonForm onAddPerson={addPerson} firms={firms} />
            <button onClick={() => setIsPersonFormOpen(false)} className="close-modal-button">
              Zatvori
            </button>
          </Modal>

          {/* Modal za upravljanje firmama */}
          <FirmManager 
            isOpen={isFirmManagerOpen}
            onClose={() => setIsFirmManagerOpen(false)}
            firms={firms} 
            setFirms={setFirms} 
            moveUsersToDefaultFirm={moveUsersToDefaultFirm}
          />

          <Modal
              isOpen={isArchivedPersonsModalOpen}
              onRequestClose={() => setIsArchivedPersonsModalOpen(false)}
              contentLabel="Arhivirane osobe"
              className="modal archived-persons-modal"
              overlayClassName="overlay"
            >
              <div className="modal-header">
                <h2>Arhivirane osobe</h2>
                <button onClick={() => setIsArchivedPersonsModalOpen(false)} className="close-modal-button">&times;</button>
              </div>
              <table>
                <thead>
                  <tr>
                    <th>Ime</th>
                    <th>Firma</th>
                    <th>Arhivirano</th>
                    <th>Akcija</th>
                  </tr>
                </thead>
                <tbody>
                  {people
                    .filter((person) => person.archived)
                    .sort((a, b) => {
                      // Prvo pretvaramo mjesec/godinu u datum za usporedbu
                      const dateA = new Date(a.archiveYear, a.archiveMonth - 1);
                      const dateB = new Date(b.archiveYear, b.archiveMonth - 1);
                      // Sortiramo silazno (od najnovijeg prema najstarijem)
                      return dateB - dateA;
                    })
                    .map((person) => (
                      <tr key={person.id}>
                        <td>{person.name}</td>
                        <td>{getFirmName(person.firmId)}</td>
                        <td>
                          {person.archiveMonth}/{person.archiveYear}
                        </td>
                        <td>
                          <button className='manage-firms-button' onClick={() => unarchivePerson(person.id)}>Odarhiviraj</button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </Modal>

          {/* Modal za prikaz učitanih tjedana */}
          <Modal
            isOpen={isUploadedWeeksModalOpen}
            onRequestClose={() => setIsUploadedWeeksModalOpen(false)}
            contentLabel="Učitani tjedni"
            className="modal uploaded-weeks-modal"
            overlayClassName="overlay"
          >
            <button
              className="close-modal-button"
              onClick={() => setIsUploadedWeeksModalOpen(false)}
            >
              ×
            </button>
            <h2>Učitani tjedni</h2>
            {uploadedWeeks.length > 0 ? (
              <ul>
                {uploadedWeeks
                  .sort((a, b) => {
                    // Prvo sortiraj po firmi
                    const firmAName = getFirmName(a.firmId);
                    const firmBName = getFirmName(b.firmId);
                    const firmCompare = firmAName.localeCompare(firmBName);
                    if (firmCompare !== 0) return firmCompare;
                    
                    // Ako su firme iste, sortiraj po tjednu
                    return parseInt(a.week) - parseInt(b.week);
                  })
                  .map((week) => (
                    <li key={week.id}>
                      <div className="week-info">
                        <span className="firm-name">{getFirmName(week.firmId)}</span>
                        <span className="week-number">Tjedan {week.week}</span>
                        <span className="filename">{week.filename}</span>
                      </div>
                      <button
                        className="delete-week-button"
                        onClick={() => deleteEarningsForWeek(week.week, week.firmId)}
                      >
                        IZBRIŠI
                      </button>
                    </li>
                  ))}
              </ul>
            ) : (
              <div className="no-weeks">Nema učitanih tjedana</div>
            )}
          </Modal>

          {/* Omotavanje tablice u scrollable div */}
          <div className="table-container">
            <PersonTable
              people={people}
              earningsData={earningsData}
              userPeriodData={userPeriodData}
              selectedNationality={selectedNationality}
              updateEarnings={updateEarnings}
              selectedPeriod={selectedPeriod}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              onDeletePerson={handleDeletePerson}
              onUpdatePerson={handleUpdatePerson}
              refreshData={refreshData}
              firms={firms} 
              selectedFirm={selectedFirm} 
            />
          </div>
          <br />
          <div className="table-container">
            <PaymentTable
              people={people}
              earningsData={earningsData}
              userPeriodData={userPeriodData}
              selectedYear={selectedYear}
              selectedMonth={selectedMonth}
              selectedPeriod={selectedPeriod}
              selectedNationality={selectedNationality}
              selectedFirm={selectedFirm} 
              firms={firms}
              updateNapomena={updateNapomena} 
            />
          </div>
        </div>
      ) : (
        <Login />
      )}
    </div>
  );
}

export default App;
